import React from 'react';
import { motion } from 'framer-motion';

const products = [
  {
    category: "(銷售) 展覽板系列",
    title: "Ucs展覽板系列",
    desc: "N型展板。門廳告示板。UCS展覽板。可攜式展覽板。折疊式展覽板。組合式攤位。投射燈",
    img: "https://images.unsplash.com/photo-1544928147-79a2dbc1f389?auto=format&fit=crop&q=80&w=800",
    tag: "銷售"
  },
  {
    category: "(銷售) 展示櫃系列",
    title: "展示/拍賣/珠寶/鈦金/陳列櫃類",
    desc: "各款玻璃櫃。珠寶櫃。鐘錶櫃。陳列桌檯。壓克力燈箱檯。恆濕氣密櫃。鈦金櫃",
    img: "https://images.unsplash.com/photo-1578305011741-2a1c0d48cc26?auto=format&fit=crop&q=80&w=800",
    tag: "銷售"
  },
  {
    category: "(銷售) 摺疊式展示版",
    title: "Ucs展覽板系列",
    desc: "功能方便摺疊式展示板。不需要組裝, 沒有煩人的配件, 彈指間可搬動。",
    img: "https://images.unsplash.com/photo-1531053306636-2283a3f256e0?auto=format&fit=crop&q=80&w=800",
    tag: "銷售"
  },
  {
    category: "(出租) 展示櫃系列",
    title: "展示/拍賣/珠寶/鈦金/陳列櫃類",
    desc: "各款玻璃 / 無框邊展櫃。展示 / 拍賣會場組合。壓克力燈箱檯。陳列桌檯",
    img: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&q=80&w=800",
    tag: "出租"
  },
  {
    category: "(銷售) 科板。競賽板",
    title: "科學展覽與創意製作",
    desc: "科學展覽板。紙科板。專題及創意製作競賽板",
    img: "https://images.unsplash.com/photo-1557804506-669a67965ba0?auto=format&fit=crop&q=80&w=800",
    tag: "銷售"
  },
  {
    category: "鈦金櫃/恆濕氣密櫃/宮廟寶物陳列櫃",
    title: "高端珍品陳列",
    desc: "宮廟鎮殿寶物展覽櫃。可定製尺寸符合特殊需求。",
    img: "https://images.unsplash.com/photo-1605814587883-9b8e8f815234?auto=format&fit=crop&q=80&w=800",
    tag: "定製"
  },
  {
    category: "活動展覽牆",
    title: "含掛畫軌道展牆",
    desc: "活動式展覽牆板。(ok)w型。SN平面展覽牆-波浪形排列。波浪形排列",
    img: "https://images.unsplash.com/photo-1577083552431-6e5fd01988ec?auto=format&fit=crop&q=80&w=800",
    tag: "租售"
  },
  {
    category: "Ok 公佈欄",
    title: "室內外公佈欄系列",
    desc: "室內外型公佈欄。室內型公佈欄。戶外型公佈欄",
    img: "https://images.unsplash.com/photo-1586282391129-76a6df230234?auto=format&fit=crop&q=80&w=800",
    tag: "銷售"
  },
  {
    category: "標示。導覽牌系列",
    title: "Ok 校園導覽牌等",
    desc: "立式 /貼壁 / 懸吊標示。樓層索引。戶外導覽牌。方向指引。桌上名牌。室內外燈箱標示。壓克力。鈦金牌。室內外LED標示牌",
    img: "https://images.unsplash.com/photo-1596495578065-6e0763fa1178?auto=format&fit=crop&q=80&w=800",
    tag: "銷售"
  },
  {
    category: "(租售) 珠寶櫃專區",
    title: "展示/拍賣/珠寶/鈦金/陳列櫃類",
    desc: "小馬櫃。低櫃。角立櫃。高櫃。傳櫃(低櫃附鑑賞照明)。珠寶。玉石。古董",
    img: "https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?auto=format&fit=crop&q=80&w=800",
    tag: "租售"
  },
  {
    category: "可攜式快速展板",
    title: "展覽會場佈展",
    desc: "修正2 800。佈展。攜帶輕巧。方便。 快速安裝。 適用於 : 各展覽會場。 賣場。醫院。學校 …等。",
    img: "https://images.unsplash.com/photo-1544928147-79a2dbc1f389?auto=format&fit=crop&q=80&w=800",
    tag: "銷售"
  },
  {
    category: "(出租) 展覽板系列",
    title: "會場硬體設備",
    desc: "N型展板。UCS展板。門廳告示板。科板。攤位。陳列桌檯。接待桌檯。投射燈。桌/椅。",
    img: "https://images.unsplash.com/photo-1505373877841-8d25f7d46678?auto=format&fit=crop&q=80&w=800",
    tag: "出租"
  }
];

export default function ProductGrid() {
  return (
    <section id="products" className="py-20 bg-slate-50">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-800 mb-4">所有產品分類介紹</h2>
          <div className="w-24 h-1 bg-amber-500 mx-auto rounded-full"></div>
          <p className="mt-4 text-slate-600 max-w-2xl mx-auto">
            我們提供多樣化的展示設備，無論是租借或購買，都能滿足您各種展覽、拍賣、校園或商業展示的需求。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
          {products.map((product, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bg-white rounded-2xl overflow-hidden shadow-lg shadow-slate-200/50 hover:shadow-xl transition-all duration-300 group border border-slate-100"
            >
              <div className="relative h-48 overflow-hidden">
                <div className="absolute top-4 left-4 z-10">
                  <span className="bg-amber-500 text-white text-xs font-bold px-3 py-1 rounded-full shadow-md">
                    {product.tag}
                  </span>
                </div>
                <img 
                  src={product.img} 
                  alt={product.title} 
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 to-transparent opacity-60"></div>
                <h3 className="absolute bottom-4 left-4 right-4 text-white font-bold text-lg leading-tight">
                  {product.category}
                </h3>
              </div>
              <div className="p-6">
                <h4 className="text-amber-600 font-medium text-sm mb-2">{product.title}</h4>
                <p className="text-slate-600 text-sm leading-relaxed line-clamp-3">
                  {product.desc}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}